import * as actionTypes from './actionTypes';
import * as rd2ApiManager from '../lib/rd2ApiManager';
import { Dispatch } from 'redux';

export interface PacPatientInfoRequest {
	firstName: string;
	lastName: string;
	middleName?: string;
	dateOfBirth?: string;
	gender?: string;
	phoneNumber?: string;
	email?: string;
	addressLine1?: string;
	addressLine2?: string;
	cityName?: string;
	stateCode?: string;
	zipCode?: string;
	homePhone?: string;
	mobilePhone?: string;
	alternatePhone?: string;
	patientId?: number;
}

export interface GetPatientCoverageCriteria {
	patient: PacPatientInfoRequest;
	dataValidityInDays: number;
	enableAutoFetch: boolean;
	forceRefresh?: boolean;
}

export function requestPacDemographicsAction(patientInfo: PacPatientInfoRequest) {
	return {
		type: actionTypes.PATIENT_ACCESS_CURATOR_GET_DEMOGRAPHICS,
		payload: {
			request: rd2ApiManager.createRequest_GetPacDemographics(patientInfo),
		},
	};
}

export function requestPacDemographics(patientInfo: PacPatientInfoRequest) {
	return (dispatch: Dispatch) => {
		return dispatch(requestPacDemographicsAction(patientInfo));
	};
}

export function getPatientCoverage(criteria: GetPatientCoverageCriteria) {
	return (dispatch: Dispatch) => {
		return dispatch(getPatientCoverageAction(criteria));
	};
}

export function getPatientCoverageAction(criteria: GetPatientCoverageCriteria) {
	return {
		type: actionTypes.PATIENT_ACCESS_CURATOR_GET_PATIENT_COVERAGE,
		payload: {
			request: rd2ApiManager.createRequest_GetPatientCoverage(criteria as any),
		},
	};
}
